"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.personalRegisterReducer = exports.personalRegisterActions = exports.TYPES = exports.SITE_LIST_PROP_CODE = exports.LOADING_STATUS = exports.INIT_STATE = exports.CONTENTS = void 0;
var _reduxActions = require("redux-actions");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const REGISTER = 'personalRegister';

/**
 * アクションタイプ
 */
const TYPES = exports.TYPES = {
  SET_CONTENT: REGISTER + 'SetContent',
  SET_ENTRY: REGISTER + 'SetEntry',
  SET_ENTRIES: REGISTER + 'SetEntries',
  SET_AREA_SITE_INFO: REGISTER + 'SetAreaSiteInfo',
  SET_MARKER_POPUP: REGISTER + 'SetMarkerPopup',
  CLEAR: REGISTER + 'Clear'
};

/**
 * コンテンツタイプ
 */
const CONTENTS = exports.CONTENTS = {
  ENTER: 'enter',
  RESULT: 'result'
};

// 情報取得中ステータス
const LOADING_STATUS = exports.LOADING_STATUS = {
  NOW_LOADING: '0',
  DATA_COMPLETED: '1'
};

/**
 * 拠点マルチトグル
 */
const SITE_LIST_PROP_CODE = exports.SITE_LIST_PROP_CODE = {
  // リストから探す
  LIST_SEARCH: '1',
  // リストにない拠点を入力する
  INPUT_LIST: '2'
};

/**
 * 初期State
 */
const INIT_STATE = exports.INIT_STATE = {
  dispContent: CONTENTS.ENTER,
  entries: {
    // 勤務場所
    workRenkeiFlg: true,
    siteListProp: null,
    workTdfkCd: '',
    areaCd: '',
    siteNo: '',
    siteBuildingNm: '',
    siteOtherNm: '',
    siteOtherTdfkCd: '',
    workUpdDt: '',
    // 自宅場所
    homeRenkeiFlg: true,
    homeTdfkCd: '',
    homeUpdDt: '',
    masterFlg: true,
    // その他滞在場所
    otherTdfkCd: '',
    otherUpdDt: '',
    // メールアドレス
    mailAddress1: '',
    mailAddress2: '',
    mailAddress3: '',
    mailUpdDt: '',
    // 情報取得中ステータス
    loadingStatus: LOADING_STATUS.NOW_LOADING
  },
  areaSiteInfo: [],
  markerPopup: {
    position: null,
    polygonInfo: null
  }
};

/**
 * アクション定義
 */
const personalRegisterActions = exports.personalRegisterActions = (0, _reduxActions.createActions)({
  [TYPES.SET_CONTENT]: function () {
    return {
      content: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.SET_ENTRY]: function () {
    return {
      key: arguments.length <= 0 ? undefined : arguments[0],
      value: arguments.length <= 1 ? undefined : arguments[1]
    };
  },
  [TYPES.SET_ENTRIES]: function () {
    return {
      entries: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.SET_AREA_SITE_INFO]: function () {
    return {
      areaSiteInfo: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.SET_MARKER_POPUP]: function () {
    return {
      position: arguments.length <= 0 ? undefined : arguments[0],
      data: arguments.length <= 1 ? undefined : arguments[1]
    };
  }
}, TYPES.CLEAR);

/**
 * Reducer定義
 */
const personalRegisterReducer = exports.personalRegisterReducer = (0, _reduxActions.handleActions)({
  [TYPES.SET_CONTENT]: (state, action) => {
    return _objectSpread(_objectSpread({}, state), {}, {
      dispContent: action.payload.content
    });
  },
  [TYPES.SET_ENTRY]: (state, action) => {
    return _objectSpread(_objectSpread({}, state), {}, {
      entries: _objectSpread(_objectSpread({}, state.entries), {}, {
        [action.payload.key]: action.payload.value
      })
    });
  },
  [TYPES.SET_ENTRIES]: (state, action) => {
    return _objectSpread(_objectSpread({}, state), {}, {
      entries: _objectSpread(_objectSpread(_objectSpread({}, state.entries), action.payload.entries), {}, {
        loadingStatus: LOADING_STATUS.DATA_COMPLETED
      })
    });
  },
  [TYPES.SET_AREA_SITE_INFO]: (state, action) => {
    return _objectSpread(_objectSpread({}, state), {}, {
      areaSiteInfo: [...action.payload.areaSiteInfo]
    });
  },
  [TYPES.SET_MARKER_POPUP]: (state, action) => _objectSpread(_objectSpread({}, state), {}, {
    markerPopup: _objectSpread(_objectSpread({}, state.markerPopup), {}, {
      position: action.payload.position,
      polygonInfo: action.payload.data
    })
  }),
  [TYPES.CLEAR]: () => {
    return _objectSpread({}, INIT_STATE);
  }
}, INIT_STATE);